import type { FunctionComponent } from 'react';

import { isMemberLoggedIn } from '@trello/authentication';
import { useFeatureGate } from '@trello/feature-gate-client';

import { LoggedInHeaderSkeleton } from './LoggedInHeaderSkeleton';
import { LoggedOutHeaderSkeleton } from './LoggedOutHeaderSkeleton';
import { RedesignedLoggedInHeaderSkeleton } from './RedesignedLoggedInHeaderSkeleton';

interface HeaderSkeletonProps {
  backgroundColor?: string;
}

export const HeaderSkeleton: FunctionComponent<HeaderSkeletonProps> = ({
  backgroundColor,
}) => {
  const { value: isPersonalProdEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  const SkeletonComponent = isPersonalProdEnabled
    ? RedesignedLoggedInHeaderSkeleton
    : LoggedInHeaderSkeleton;

  if (isMemberLoggedIn()) {
    return <SkeletonComponent backgroundColor={backgroundColor} />;
  }

  return <LoggedOutHeaderSkeleton />;
};
